import React from "react";

function Logo() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="svg"
      viewBox="0 0 419 419">
      <g id="Logo" transform="translate(-375 -489)">
        <g id="Background">
          <g
            id="svg-background"
            data-name="Rectangle 1"
            transform="translate(375 489)"
            fill="#2d2e35"
            stroke="#fff"
            strokeWidth="30">
            <rect width="419" height="419" stroke="none" />
            <rect x="15" y="15" width="389" height="389" fill="none" />
          </g>
        </g>
        <g id="Text">
          <text
            id="Md"
            transform="translate(458 786)"
            fill="#fff"
            fontSize="180"
            fontFamily="ProductSans-Regular, Product Sans">
            <tspan x="0" y="0">
              Md
            </tspan>
          </text>
          <text
            id="_01"
            data-name="01"
            transform="translate(436 598)"
            fill="#fff"
            fontSize="60"
            fontFamily="ProductSans-Regular, Product Sans">
            <tspan x="0" y="0">
              01
            </tspan>
          </text>
        </g>
      </g>
    </svg>
  );
}

export default Logo;
